import { MARKETS } from '../lib/brand';

export const MarketButtons = ({ value, onChange, prefix, compact = false }) => (
  <div role="radiogroup" aria-label="Market" className={`grid gap-2 ${compact ? 'grid-cols-3 sm:grid-cols-6' : 'grid-cols-3'}`} data-testid={`${prefix}-market-group`}>
    {MARKETS.map((m) => {
      const active = value === m.code;
      return (
        <button
          key={m.code}
          type="button"
          role="radio"
          aria-checked={active}
          onClick={() => { if (!active) onChange(m.code); }}
          data-testid={`${prefix}-market-${m.code}`}
          className={`rounded-md border px-2 ${compact ? 'py-2' : 'py-2.5'} min-h-[44px] flex flex-col items-center justify-center transition-colors select-none ${
            active ? 'bg-brand border-brand text-black cursor-default' : 'bg-black border-zinc-800 text-zinc-300 hover:border-brand/60 active:bg-zinc-900'
          }`}
        >
          <span className="font-mono font-bold text-sm leading-none">{m.code}</span>
          {!compact && <span className={`text-[10px] mt-1 leading-none ${active ? 'text-black/70' : 'text-zinc-500'}`}>{m.region}</span>}
        </button>
      );
    })}
  </div>
);
